module.exports = __webpack_public_path__ + "img/hw_logo2.06881d00.png";